import React, { useEffect, useRef, useState } from "react";
import { Popover } from "react-tiny-popover";
import cs from "classnames";
import { ReactComponent as DropdownIcon } from "../../../assets/Icon/dropdown.svg";

const OptionList = ({
  opt,
  handleSubOptionClick,
  optionVal,
  value,
  labelVal,
  handleClick,
  isOtherPopoverOpe,
  index,
}) => {
  const ref = useRef<any>();
  const [showSubMenu, setShowSubMenu] = useState(false);
  useEffect(() => {
    isOtherPopoverOpe.current = showSubMenu;
  }, [showSubMenu]);

  return (
    <Popover
      isOpen={showSubMenu}
      positions={["right", "left", "bottom", "top"]}
      align="start"
      content={
        <ul
          className="submenu-options"
          onMouseEnter={() => setShowSubMenu(true)}
          onMouseLeave={() => setShowSubMenu(false)}
        >
          {opt.subOption.map((sub_o, i) => {
            return (
              <li
                key={`${i}--${sub_o.label}`}
                className={cs("select-option", {
                  ["selected-option-active"]: optionVal === sub_o.value,
                })}
                onClick={(e) => {
                  e.stopPropagation();
                  handleSubOptionClick(opt, sub_o);
                }}
              >
                {sub_o.label}
              </li>
            );
          })}
        </ul>
      }
    >
      <li
        className={cs("select-option", {
          ["selected-option-active"]:
            (value ? value === opt.value : labelVal.value === opt.value) ||
            showSubMenu,
        })}
        ref={ref}
        onMouseEnter={() => setShowSubMenu(true)}
        onMouseLeave={() => setShowSubMenu(false)}
        onClick={() => {
          handleClick(opt)();
        }}
        key={`${index}--option-list`}
      >
        <span>{opt.label}</span>
        <DropdownIcon className="icon-dropdown more-option" />
      </li>
    </Popover>
  );
};

export default OptionList;
